import React from 'react';
import { Link } from 'react-router-dom';
import { paths } from '../routes/paths';

export default function NotFound() {
  return (
    <div style={{ textAlign: 'center', padding: '64px 20px' }}>
      <h1 style={{ fontSize: 48, margin: 0 }}>404</h1>
      <h2 style={{ margin: '8px 0 12px' }}>Page not found</h2>
      <p style={{ color: 'var(--t-muted)', marginBottom: 24 }}>The page you are looking for doesn't exist or has moved.</p>
      <Link to={paths.home} className="btn btn-primary">Back to home</Link>
    </div>
  );
}
